
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resize-webp",
      function () {
        return require("private-next-pages/resize-webp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resize-webp"])
      });
    }
  